import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper glass-tile" }
const _hoisted_2 = { class: "footer-version" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "© 2024 Wojciech Bocho", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoElem = _resolveComponent("LogoElem")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", {
      class: "footer-logo",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoScroll && _ctx.logoScroll(...args)))
    }, [
      _createVNode(_component_LogoElem)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, "Portfolio v" + _toDisplayString(_ctx.appVersion), 1),
      _hoisted_3
    ])
  ]))
}